'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emitter = new _events2.default();

var mediaEvents = {
  event: function event() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    this._event = args.join('.');
    return this;
  },
  listen: function listen(handler) {
    emitter.on(this._event, handler);
  },
  remove: function remove(handler) {
    emitter.off(this._event, handler);
  },
  emit: function emit(data) {
    emitter.emit(this._event, data);
  }
};

exports.default = mediaEvents;